import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import {
  AlertBanner,
  Button,
  Checkbox,
  ModalIsland,
} from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { useInvertedLocalize } from '../../../utils/localization';
import { getMessageKey } from '../../../utils/utils';

import { invertedMessages } from './messages';

import './CertsConsultWarnModal.css';

function CertsConsultWarnModal({
  isConsultWarnModalOpen,
  handleClose,
  handleWarnModal,
  isActionLoading,
  errorMessage,
  isActionSuccess,
  warnText,
  btnText,
  showCheckBox,
  title,
}) {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const { messages } = useSelector((state) => state?.user);

  const l = useInvertedLocalize(invertedMessages);

  const onCancel = () => setIsVisible(false);

  useEffect(() => {
    setIsOpen(isConsultWarnModalOpen);
  }, [isConsultWarnModalOpen]);

  useEffect(() => {
    if (isActionSuccess) {
      handleClose();
    }
  }, [isActionSuccess]);

  useEffect(() => {
    if (errorMessage) {
      setIsVisible(true);
    } else if (isVisible) setIsVisible(false);
  }, [errorMessage]);

  const getConsultWarnModal = () => (
    <ModalIsland
      kind='warning'
      className='CertsConsultWarnModal'
      alertTitle={
        <>
          {title}
          <AlertBanner
            colorTheme='Critical'
            title='Error'
            description={errorMessage}
            isVisible={isVisible}
            onCancel={onCancel}
          />
        </>
      }
      alertSubtitle={warnText}
      onClose={() => {
        // close modal
        handleClose();
      }}
      isOpen={isOpen}
      primaryButton={
        <>
          {showCheckBox && (
            <Checkbox
              id='consult-warning-modal-checkbox'
              name='checkbox0'
              kind='singleLine'
              dataTestId='checkbox0'
              isChecked={isChecked}
              onChange={(event) => {
                setIsChecked(event.target.checked);
              }}
              label={l('Don’t show this again for this certification')}
              textPosition='after'
            />
          )}
          <Button
            type='button'
            kind='outlined'
            size='medium'
            isDisabled={isActionLoading}
            isLoading={isActionLoading}
            loaderText={btnText}
            onClick={() => {
              handleWarnModal(isChecked);
            }}>
            {btnText}
          </Button>
        </>
      }
      secondaryButton={
        <Button
          type='button'
          kind='ghost'
          size='medium'
          onClick={handleClose}
          isDisabled={isActionLoading}>
          {messages.CERTS_CANCEL ||
            localize(intl, getMessageKey('CERTS_CANCEL'))}
        </Button>
      }
    />
  );

  return <section>{getConsultWarnModal()}</section>;
}

CertsConsultWarnModal.propTypes = {
  isConsultWarnModalOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  handleWarnModal: PropTypes.func,
  isActionLoading: PropTypes.bool,
  errorMessage: PropTypes.string,
  isActionSuccess: PropTypes.bool,
  warnText: PropTypes.string,
  btnText: PropTypes.string,
  showCheckBox: PropTypes.bool,
  title: PropTypes.string,
};

CertsConsultWarnModal.defaultProps = {
  isConsultWarnModalOpen: false,
  handleClose: () => {},
  handleWarnModal: () => {},
  isActionLoading: false,
  errorMessage: null,
  isActionSuccess: false,
  warnText: '',
  btnText: '',
  showCheckBox: false,
  title: '',
};

export default CertsConsultWarnModal;
